import { CAST_PILOT_ASSISTANT } from '@cast/constants';

import { Typography, Box, tokens } from '@cast/design-system';

type ThinkingBubbleProps = {
  text?: string;
};

export const ThinkingBubble = ({ text }: ThinkingBubbleProps = {}) => {
  const hasStreamedText = !!text?.trim();

  return (
    <Box
      data-testid="chat-thinking-bubble"
      sx={{
        p: 8,
        border: 'none',
        borderRadius: '8px',
        backgroundColor: tokens.theme.bg.structural.surface,
        maxWidth: '100%',
        minWidth: '100px',
        alignSelf: 'flex-start',
      }}
    >
      <Typography color={tokens.theme.fg.structural.secondary} variant="P10B">
        {CAST_PILOT_ASSISTANT}:
      </Typography>
      <Typography
        variant="P14R"
        color={tokens.theme.fg.structural.secondary}
        data-testid={hasStreamedText ? 'chat-thinking-text' : undefined}
        sx={{
          animation: 'thinking-blink 1s ease-in-out infinite',
          '@keyframes thinking-blink': {
            '0%': {
              opacity: 1,
            },
            '50%': {
              opacity: 0.1,
            },
            '100%': {
              opacity: 1,
            },
          },
        }}
      >
        {hasStreamedText ? text : 'Thinking...'}
      </Typography>
    </Box>
  );
};
